/* eslint-disable no-param-reassign */
import { createSelector, createSlice } from '@reduxjs/toolkit';
import type { Reducer } from 'redux';

import Portal from '../types/Portal';
import { setUser } from './user';

interface State {
  isLoggedIn: boolean;
  portal: Portal;
}

const initialState: State = {
  isLoggedIn: false,
  portal: null,
};

const slice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    setPortal(state, { payload: portal }) {
      return {
        ...state,
        portal,
      };
    },
  },
  extraReducers: builder => {
    builder.addCase(setUser, (state, { payload }) => {
      state.isLoggedIn = !!payload?.email;
    });
  },
});

// Explicit reducer annotation avoids TS2742 during declaration emit after the RTK 2 upgrade.
const { reducer }: { reducer: Reducer<State> } = slice;

export default reducer;

export const getIsLoggedIn = state => state[slice.name];
const getPortal = state => state[slice.name]?.portal;

export const checkPortal = createSelector([getPortal], portal => ({
  isExperiencePortal: portal === Portal.Experience,
  isCompanyPortal: portal === Portal.CompanyPortal,
}));
export const { setPortal } = slice.actions;
